

























































/* eslint-disable @typescript-eslint/no-var-requires */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Routes } from '@rs-911/router/routes';

@Component
export default class AvailableFeatures extends Vue {
  routes = Routes;

  created() {
    //
  }

  downloadQR() {
    this.$store.dispatch('medInfo/getQrCode', 300).then(res => {
      const a = document.createElement('a');
      a.href = 'data:image/png;base64,' + res.data.qrCode;
      a.download = 'QR-Code.png';
      a.click();
    });
  }

  // NOT IN USE
  generateAvery() {
    const canvas = document.getElementById('canvas') as any;
    const context = canvas.getContext('2d');
    const image = require('@rs-911/assets/avery.png');
    const img1 = new Image();
    const img2 = new Image();

    img1.onload = () => {
      canvas.width = img1.width;
      canvas.height = img1.height;
      // img2.src = this.medinfoQr;
    };
    img2.onload = () => {
      context.globalAlpha = 1.0;
      context.drawImage(img1, 0, 0);
      // context.globalAlpha = 0.5; //Remove if pngs have alpha
      context.drawImage(img2, 290, 20, img2.width*1.5, img2.height*1.5);
    };        

    img1.src = image;


    const link = document.createElement('a');
    link.download = 'filename.png';
    link.href = (document.getElementById('canvas') as any).toDataURL();
  }

  async generatePDF() {
    const qrMedinfo = await this.$store.dispatch('medInfo/getQrCode', 300);
    const pdfMake = require('pdfmake/build/pdfmake.min.js');
    const date = new Date();
    if (pdfMake.vfs == undefined){
      const pdfFonts = require('pdfmake/build/vfs_fonts.js');
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
    }
    this.$store.dispatch('medInfo/getUserMedicalInfo').then(res => {
      const docDefinition = {
        pageMargins: [40, 100, 40, 60],
        footer: function(currentPage: number, pageCount: number) { return [
          { text: currentPage.toString() + ' of ' + pageCount, margin: [20, 20], alignment: 'right'},
          { text: date.toLocaleDateString(), margin: [20, 20], alignment: 'left'}
        ];
        },
        header: { width: 60, margin: [20, 20], image: 'data:image/png;base64,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' },
        content: [
          {text: 'MEDICAL INFORMATION', style: 'header'},
          {text: '\n',},
          {
            alignment: 'justify',
            columns: [
              {
                stack: [
                  {text: `Gender: ${res.data.personalInfo.gender}`, style: 'personalInfoText'},
                  {text: `Date Of Birth: ${new Date(res.data.personalInfo.dateOfBirth).toLocaleDateString()}`, style: 'personalInfoText'},
                  {text: `Age: ${res.data.personalInfo.age}`, style: 'personalInfoText'}
                ]
              },
              { width: 240, margin: [-10, -10], image: 'data:image/png;base64,' + qrMedinfo.data.qrCode }
            ]
          },
          {text: (res.data.allergies.length ? 'Allergies' : 'No Allergies'), style: 'subheader'},
          res.data.allergies.length ?
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: ['*', '*', '*'],
              body: [
                [{text: 'Name', style: 'tableHeader'}, {text: 'Severity', style: 'tableHeader'}, {text: 'Epi Pen', style: 'tableHeader'}],
                ...res.data.allergies.map((x: any) => {
                  const arr = [];
                  arr.push({text: x.name});
                  arr.push({text: x.severity});
                  arr.push({text: x.epiPenRequired ? 'Yes' : 'No'});
                  return arr;
                }),
              ]
            }
          } : {text: ''},
          {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ], margin: [0, 20]},
          {text: (res.data.diagnoses.length ? 'Diagnoses' : 'No Diagnoses'), style: 'subheader'},
          res.data.diagnoses.length ?
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: ['*', '*'],
              body: [
                [{text: 'Name', style: 'tableHeader'}, {text: 'Physician\'s Name', style: 'tableHeader'}],
                ...res.data.diagnoses.map((x: any) => {
                  const arr = [];
                  arr.push({text: x.name});
                  arr.push({text: x.physicianFullName});
                  return arr;
                }),
              ]
            }
          } : {text: ''},
          {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ], margin: [0, 20]},
          {text: (res.data.medications.length ? 'Medications' : 'No Medications'), style: 'subheader'},
          res.data.medications.length ?
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: ['*', '*', '*'],
              body: [
                [{text: 'Name', style: 'tableHeader'}, {text: 'Dosage', style: 'tableHeader'}, {text: 'Physician Name', style: 'tableHeader'}],
                ...res.data.medications.map((x: any) => {
                  const arr = [];
                  arr.push({text: x.name});
                  arr.push({text: x.dosage});
                  arr.push({text: x.physicianFullName});
                  return arr;
                }),
              ]
            }
          } : {text: ''},
          {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ], margin: [0, 20]},
          {text: (res.data.physicians.length ? 'Physicians' : 'No Physicians'), style: 'subheader'},
          res.data.physicians.length ?
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: ['*', '*', '*'],
              body: [
                [{text: 'Name', style: 'tableHeader'}, {text: 'Specialty', style: 'tableHeader'}, {text: 'Phone Number', style: 'tableHeader'}],
                ...res.data.physicians.map((x: any) => {
                  const arr = [];
                  arr.push({text: x.fullName});
                  arr.push({text: x.specialty});
                  arr.push({text: x.phoneNumber});
                  return arr;
                }),
              ]
            }
          } : {text: ''},
          res.data.otherMedicalInfo ? 
          {
            stack: [
              {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ], margin: [0, 20]},
              {text: (res.data.otherMedicalInfo ? 'Other Medical Info' : ''), style: 'subheader'},
              {text: res.data.otherMedicalInfo}
            ]

          } : 
          {}
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          },
          subheader: {
            fontSize: 15,
            margin: [0, 10],
            bold: true
          },
          tableExample: {
            margin: [0, 5, 0, 15]
          },
          personalInfoText: {
            margin: [0, 0, 0, 5]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        }
      };

      pdfMake.createPdf(docDefinition).download('medical-information.pdf');
    })
    .catch((err) => {
      this.$store.dispatch('notify', {title: 'Error while generating PDF Report', body: err, variant: 'danger'});
    });
  }
}
